/**
 * API Configuration
 * Always uses VITE_API_URL since frontend and backend are separate services
 */
export const API_BASE_URL = import.meta.env.VITE_API_URL || 'http://localhost:3001'

export const API_ENDPOINTS = {
  auth: {
    login: `${API_BASE_URL}/api/auth/login`,
    verify: `${API_BASE_URL}/api/auth/verify`,
  },
  containers: {
    all: `${API_BASE_URL}/api/containers`,
    expected: `${API_BASE_URL}/api/containers/expected`,
    onYard: `${API_BASE_URL}/api/containers/on-yard`,
    import: `${API_BASE_URL}/api/containers/import`,
    export: `${API_BASE_URL}/api/containers/export`,
  },
  trips: {
    list: `${API_BASE_URL}/api/trips`,
    search: `${API_BASE_URL}/api/trips/search`,
    byRitNr: (ritNr: string) => `${API_BASE_URL}/api/trips/${ritNr}`,
    create: `${API_BASE_URL}/api/trips`,
    update: (ritNr: string) => `${API_BASE_URL}/api/trips/${ritNr}`,
    delete: (ritNr: string) => `${API_BASE_URL}/api/trips/${ritNr}`,
  },
  activities: {
    list: `${API_BASE_URL}/api/activities`,
    byId: (id: number) => `${API_BASE_URL}/api/activities/${id}`,
    create: `${API_BASE_URL}/api/activities`,
    update: (id: number) => `${API_BASE_URL}/api/activities/${id}`,
    delete: (id: number) => `${API_BASE_URL}/api/activities/${id}`,
  },
  activityTypes: {
    list: `${API_BASE_URL}/api/activity-types`,
    create: `${API_BASE_URL}/api/activity-types`,
    update: (id: number) => `${API_BASE_URL}/api/activity-types/${id}`,
    delete: (id: number) => `${API_BASE_URL}/api/activity-types/${id}`,
  },
  depot: {
    inStock: `${API_BASE_URL}/api/depot/in-stock`,
    checkIn: `${API_BASE_URL}/api/depot/check-in`,
  },
  ingestion: {
    sync: `${API_BASE_URL}/api/ingestion/sync`,
    status: `${API_BASE_URL}/api/ingestion/status`,
  },
  stats: `${API_BASE_URL}/api/stats`,
  users: `${API_BASE_URL}/api/users`,
}
